import { useContext, useState } from "react";
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';
import { openCreateModal } from "../../context/PrestacionesContext/Actions";
import { Grid } from "@material-ui/core";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import BodyPrestacion from "./BodyPrestacion";
import AddIcon from "../../assets/svg/icono_agregar_blue.svg";
import Cuadricula from "../../assets/svg/Cuadricula.svg";
import lista from "../../assets/svg/Lista.svg";
import CreateBenefits from "./modals/CreateBenefits";
import UpdateBenefits from "./modals/UpdateBenefits";
import PackagesPage from "./packages/PackagesPage";
import PackageRequestsContent from "./packages/PackageRequestsContent";
import CheckPermission from "../../helpers/Administradores/Permissions";
import "../Prestaciones/css/Prestaciones.css";
import Loading from '../Loading';
import loadingGif from '../../assets/loading.gif'

const PrestacionContent = () => {

  const { state, dispatch } = useContext(PrestacionContext);
  const [viewMode, setViewMode] = useState<'square' | 'list'>('square');
  const [activeTab, setActiveTab] = useState<'prestaciones' | 'paquetes' | 'aprobaciones'>('prestaciones');
  const [isCreatePackageOpen, setIsCreatePackageOpen] = useState(false);
  const [infoImg, setInfoImg] = useState({});

  // DBSB-453: punto de entrada descubrible a la bandeja de aprobaciones de cambio de
  // paquete. El circuito de aprobación ya existía (ruta /aprobaciones-paquete) pero solo
  // era accesible desde el menú del avatar (PopperHeader), donde el aprobador no lo
  // encontraba. Se expone como pestaña del módulo Prestaciones, guardada por el mismo
  // permiso que la ruta.
  const puedeAprobarPaquetes = CheckPermission('Prestaciones.Paquetes.Aprobar');

  return (
    <>
      {/* Cabecera: título + botón de creación contextual */}
      <div className="contenedorHead">
        <Box mt={3} ml={5} className="Title" mb={2}>
          Prestaciones
        </Box>
        <div className="conteinderBtnsPrestaciones">
          {activeTab === 'prestaciones' && (
            <>
              <div
                className={`btnViewMode ${viewMode === 'square' ? 'active' : ''}`}
                onClick={() => setViewMode('square')}
              >
                <img src={Cuadricula} alt="Cuadrícula" />
                <span>Cuadrícula</span>
              </div>
              <div
                className={`btnViewMode ${viewMode === 'list' ? 'active' : ''}`}
                onClick={() => setViewMode('list')}
              >
                <img src={lista} alt="Lista" />
                <span>Lista</span>
              </div>
              <button
                id="addPrestacion"
                onClick={() => openCreateModal(dispatch)}
                className="btnNuevaPrestacion"
              >
                <div className="alineacionBoton">
                  <img src={AddIcon} alt="Agregar Prestación" />
                  <div className="nombrePrestacion">
                    <b><span>Nueva Prestación</span></b>
                  </div>
                </div>
              </button>
            </>
          )}
          {activeTab === 'paquetes' && (
            <button
              onClick={() => setIsCreatePackageOpen(true)}
              className="btnNuevaPrestacion"
            >
              <div className="alineacionBoton">
                <img src={AddIcon} alt="Agregar Paquete" />
                <div className="nombrePrestacion">
                  <b><span>Nuevo Paquete</span></b>
                </div>
              </div>
            </button>
          )}
        </div>
      </div>

      {/* Tabs de navegación */}
      <Box sx={{ borderBottom: '1px solid #e0e0e0', px: 5 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          sx={{
            '& .MuiTabs-indicator': { backgroundColor: '#FABB00' },
            '& .MuiTab-root.Mui-selected': { color: '#093C5D', fontWeight: 600 },
            '& .MuiTab-root': { color: '#666', textTransform: 'none', fontSize: 15 },
          }}
        >
          <Tab label="Prestaciones" value="prestaciones" />
          <Tab label="Paquetes" value="paquetes" />
          {puedeAprobarPaquetes && (
            <Tab label="Aprobaciones de paquete" value="aprobaciones" />
          )}
        </Tabs>
      </Box>

      {/* Contenido por tab */}
      {activeTab === 'prestaciones' && (
        <>
          <CreateBenefits />
          {state._id !== '' && <UpdateBenefits />}
          <Grid className="containerBodyPrestacion">
            <BodyPrestacion
              infoImg={infoImg}
              viewSquare={viewMode === 'square'}
              viewList={viewMode === 'list'}
            />
          </Grid>
        </>
      )}

      {activeTab === 'paquetes' && (
        <Grid className="containerBodyPrestacion">
          <PackagesPage
            isCreateOpen={isCreatePackageOpen}
            onCloseCreate={() => setIsCreatePackageOpen(false)}
          />
        </Grid>
      )}

      {activeTab === 'aprobaciones' && puedeAprobarPaquetes && (
        <Grid className="containerBodyPrestacion">
          <PackageRequestsContent />
        </Grid>
      )}

      {state.globalLoading && (
        <Loading className="global-loading-overlay">
          <div style={{
            position: 'fixed',
            top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column'
          }}>
            <img src={loadingGif} alt="Cargando..." style={{ width: '80px' }} />
            <p style={{ marginTop: '10px', color: '#ffffffff', fontWeight: 'bold' }}>Procesando...</p>
          </div>
        </Loading>
      )}
    </>
  );
};

export default PrestacionContent;
